import Vue from 'vue';
export const globalBus = new Vue();
//这里 import 了一个 vue 类，然后实例化并且将它 export, 实际上是创建了一个与 DOM 和程序的其他部分完全解耦的组件，它仅仅是一个组件所以非常的轻量。
//可用来任何 .vue  .js 之间的交流
// 发信息方用 import { globalBus } from '@/utils/globalBus';   globalBus.$emit('eventName', data);
// 收信方用   import { globalBus } from '@/utils/globalBus';   globalBus.$on('eventName', (data) => { console.log(data) });
//  实在不好交流的用这个  其他情况优先考虑 emit props vuex
